import { useCallback } from "react";
import EligibilityListApi from "../../httpClients/EligibilityListApi";
import useOptions from "./useOptions";

/**
 * Hook for loading eligibility reason options
 * @param {boolean} trigger - When to trigger loading (e.g., isOpen)
 * @returns {Object} { options, isLoading, error, refetch }
 */
const useEligibilityReasonOptions = (trigger = false) => {
  const apiCall = useCallback(() => {
    return EligibilityListApi.getEligibilityListReasons();
  }, []);

  const mapper = useCallback(response => {
    return (
      response?.map(reason => ({
        label: reason.name,
        value: reason
      })) || []
    );
  }, []);

  return useOptions(apiCall, mapper, trigger, {
    loadOnMount: false,
    loadOnce: true
  });
};

export default useEligibilityReasonOptions;
